import React, { useEffect, useState } from "react";
import {
  getProfileBuildingServices,
  updateOtherService,
  updateProfileBuildingService,
} from "../../../services/user.services";
import { useDispatch } from "react-redux";
import { FaEdit, FaSave, FaTimes, FaTrash } from "react-icons/fa";

function ProfileBuildingTable({
  coreServiceId,
  services,
  setServices,
  saveProfileBuildingServices,
  deleteService,
}) {
  const [editId, setEditId] = useState(null);
  const [editableData, setEditableData] = useState({});
  const dispatch = useDispatch();

  const toggleEdit = (service) => {
    setEditId(service.id);
    setEditableData({
      id: service.id,
      service_name: service.service_name || "",
      price: service.price || "",
    });
  };

  const cancelEdit = (id) => {
    if (services.find((service) => service.id === id)?.isNew) {
      setServices((prev) => prev.filter((service) => service.id !== id));
    }
    setEditId(null);
    setEditableData({});
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditableData({ ...editableData, [name]: value });
  };

  const saveEdit = async () => {
    try {
      const updatedData = {
        id: editId,
        service_name: editableData.service_name,
        price: editableData.price,
        coreservices_id: coreServiceId,
      };
      const doesExist = services.find(
        (service) => service.id === updatedData.id
      );
      if (!doesExist) {
        await saveProfileBuildingServices({
          id: editId,
          service_name: editableData.service_name,
          price: editableData.price,
          coreservices_id: coreServiceId,
        });

        setServices((prev) =>
          prev.map((item) =>
            item.id === editId
              ? { ...item, ...editableData, isNew: false }
              : item
          )
        );
      } else {
        await updateProfileBuildingService(editId, {
          id: editId,
          service_name: editableData.service_name,
          price: editableData.price,
          coreservices_id: coreServiceId,
        });

        setServices((prev) =>
          prev.map((item) =>
            item.id === editId ? { ...item, ...updatedData } : item
          )
        );
      }

      setEditId(null);
      setEditableData({});
    } catch (error) {
      console.error("Error saving the service:", error.message);
    }
  };

  const deleteRow = async (id) => {
    try {
      await deleteService(id);
      setServices(services.filter((service) => service.id !== id));
    } catch (error) {
      console.error("Error deleting the service:", error);
    }
  };

  const toggleSelect = (id) => {
    setServices(
      services.map((service) =>
        service.id === id
          ? { ...service, selected: !service.selected }
          : service
      )
    );
  };

  const loadProfileBuilding = async () => {
    try {
      const data = await getProfileBuildingServices();
      setServices(data);
    } catch (error) {
      console.error("Error fetching profileBuilding services", error);
    }
  };

  useEffect(() => {
    loadProfileBuilding();
  }, []);

  return (
    <div className="container mx-auto p-4 sm:p-6">
      {/* Desktop Table View */}
      <div className="hidden lg:block overflow-x-auto">
        <table className="min-w-full table-auto border-collapse border border-gray-300 bg-white rounded-lg shadow-sm">
          <thead>
            <tr className="bg-gray-100 text-gray-600 uppercase text-sm leading-normal">
              <th className="py-3 px-4 text-center border-b border-gray-300">
                <input type="checkbox" className="cursor-pointer" />
              </th>
              <th className="py-3 px-4 text-left border-b border-gray-300">
                SL
              </th>
              <th className="py-3 px-4 text-left border-b border-gray-300">
                Name of the Services
              </th>
              <th className="py-3 px-4 text-left border-b border-gray-300">
                Price
              </th>
              <th className="py-3 px-4 text-left border-b border-gray-300">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {services.map((service) => (
              <tr
                key={service.id}
                className="border-b border-gray-200 hover:bg-gray-50"
              >
                <td className="py-3 px-4 text-center">
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={service.selected || false}
                    onChange={() => toggleSelect(service.id)}
                  />
                </td>
                <td className="py-3 px-4 text-gray-700">{service.id}</td>
                <td className="py-3 px-4">
                  {editId === service.id || service.isNew ? (
                    <input
                      type="text"
                      name="service_name"
                      value={editableData.service_name || ""}
                      onChange={handleEditChange}
                      placeholder="Enter service name"
                      className="w-full border border-gray-300 px-2 py-1 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  ) : (
                    <span className="text-gray-800">
                      {service.service_name || "N/A"}
                    </span>
                  )}
                </td>
                <td className="py-3 px-4">
                  {editId === service.id || service.isNew ? (
                    <input
                      type="number"
                      name="price"
                      value={editableData.price || ""}
                      onChange={handleEditChange}
                      placeholder="Enter price"
                      className="w-full border border-gray-300 px-2 py-1 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  ) : (
                    <span className="text-gray-800">
                      {service.price || "N/A"}
                    </span>
                  )}
                </td>
                <td className="py-3 px-4">
                  {editId === service.id || service.isNew ? (
                    <div className="flex gap-2">
                      <button
                        onClick={saveEdit}
                        className="text-green-600 hover:text-green-800 p-1"
                        title="Save"
                      >
                        <FaSave />
                      </button>
                      <button
                        onClick={() => cancelEdit(service.id)}
                        className="text-gray-600 hover:text-gray-800 p-1"
                        title="Cancel"
                      >
                        <FaTimes />
                      </button>
                    </div>
                  ) : (
                    <div className="flex gap-2">
                      <button
                        onClick={() => toggleEdit(service)}
                        className="text-blue-600 hover:text-blue-800 p-1"
                        title="Edit"
                      >
                        <FaEdit />
                      </button>
                      <button
                        onClick={() => deleteRow(service.id)}
                        className="text-red-600 hover:text-red-800 p-1"
                        title="Delete"
                      >
                        <FaTrash />
                      </button>
                    </div>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile Card View */}
      <div className="lg:hidden space-y-4">
        {services.map((service) => (
          <div
            key={service.id}
            className="bg-white border border-gray-300 rounded-lg shadow-sm p-4"
          >
            {/* Header with checkbox and ID */}
            <div className="flex items-center justify-between mb-3 pb-2 border-b border-gray-200">
              <div className="flex items-center gap-3">
                <input
                  type="checkbox"
                  className="cursor-pointer"
                  checked={service.selected || false}
                  onChange={() => toggleSelect(service.id)}
                />
                <span className="text-sm text-gray-500">ID: {service.id}</span>
              </div>
            </div>

            {/* Service Details */}
            <div className="space-y-3">
              <div>
                <label className="block text-sm font-medium text-gray-600 mb-1">
                  Service Name
                </label>
                {editId === service.id || service.isNew ? (
                  <input
                    type="text"
                    name="service_name"
                    value={editableData.service_name || ""}
                    onChange={handleEditChange}
                    placeholder="Enter service name"
                    className="w-full border border-gray-300 px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                ) : (
                  <p className="text-gray-800 py-2">
                    {service.service_name || "N/A"}
                  </p>
                )}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-600 mb-1">
                  Price
                </label>
                {editId === service.id || service.isNew ? (
                  <input
                    type="number"
                    name="price"
                    value={editableData.price || ""}
                    onChange={handleEditChange}
                    placeholder="Enter price"
                    className="w-full border border-gray-300 px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                ) : (
                  <p className="text-gray-800 py-2">{service.price || "N/A"}</p>
                )}
              </div>
            </div>

            {/* Actions */}
            <div className="mt-4 pt-3 border-t border-gray-200">
              {editId === service.id || service.isNew ? (
                <div className="flex gap-2 w-full">
                  <button
                    onClick={saveEdit}
                    className="text-green-600 hover:text-green-800 p-1"
                    title="Save"
                  >
                    <FaSave />
                  </button>
                  <button
                    onClick={() => cancelEdit(service.id)}
                    className="text-gray-600 hover:text-gray-800 p-1"
                    title="Cancel"
                  >
                    <FaTimes />
                  </button>
                </div>
              ) : (
                <div className="flex gap-2 w-full">
                  <button
                    onClick={() => toggleEdit(service)}
                    className="text-blue-600 hover:text-blue-800 p-1"
                    title="Edit"
                  >
                    <FaEdit />
                  </button>
                  <button
                    onClick={() => deleteRow(service.id)}
                    className="text-red-600 hover:text-red-800 p-1"
                    title="Delete"
                  >
                    <FaTrash />
                  </button>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Empty State */}
      {services.length === 0 && (
        <div className="text-center py-8 text-gray-500">
          <p>No profile building services available</p>
        </div>
      )}
    </div>
  );
}

export default ProfileBuildingTable;
